import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { StepProps, Steps } from 'antd';
import { useGetRegionLabel } from 'hooks/business/useRegion';
import { MutableRefObject, useEffect, useState } from 'react';
import { regionList } from 'services/config/region';
import { toUpperCase } from 'utils/toLowerCase';
import { useGetTaskStatus } from 'views/Aide/hooks/useGetTaskStatus';
import { DescendantExecuteContext } from 'views/Aide/Scenario/PolicyForm/share';

type TaskData = Partial<Record<General.UpperCaseRegion, DescendantExecuteContext>>;

interface OutStockTaskLeftNavProps {
  regions: General.UpperCaseRegion[];
  tasks: TaskData;
  platform: General.PlatformUpperCase;
  rBasicStats: MutableRefObject<StepProps['status']>;
  rTaskStats: MutableRefObject<StepProps['status']>;
}

export const OutStockTaskLeftNav = (props: OutStockTaskLeftNavProps) => {
  const { regions, tasks, platform, rBasicStats, rTaskStats } = props;
  const { t } = useTranslate();
  const taskStatus = useGetTaskStatus();
  const getRegionLabel = useGetRegionLabel();

  const [btnOn, setBtnOn] = useState('');

  useEffect(() => {
    const intersectionOb = new IntersectionObserver((entries) => {
      const { 0: ent } = entries;
      if (ent.isIntersecting) {
        const id = ent.target.getAttribute('data-step');
        if (id) {
          setBtnOn(id);
        }
      }
    });

    const btns = Array.from(document.querySelectorAll('[data-step]'));

    btns.forEach((v) => {
      if (v) {
        intersectionOb.observe(v);
      }
    });

    return () => {
      intersectionOb.disconnect();
    };
  }, [regions]);

  return (
    <LeftNav>
      <Steps direction="vertical" size="small">
        <Steps.Step
          status={rBasicStats.current}
          data-on={`${btnOn === 'taskBasic' ? 'on' : ''}`}
          title={
            <span
              onClick={() => {
                document.querySelector('[data-step=taskBasic]')?.scrollIntoView();
                setBtnOn('taskBasic');
              }}
            >
              {t('aide.基础配置')}
            </span>
          }
        />
        {regions.length === 0 ? (
          <Steps.Step
            status="wait"
            data-on={`${btnOn === 'taskTip' ? 'on' : ''}`}
            title={
              <span
                onClick={() => {
                  document.querySelector('[data-step=taskTip]')?.scrollIntoView();
                  setBtnOn('taskTip');
                }}
              >
                {t('aide.发送内容')}
              </span>
            }
          />
        ) : (
          <>
            {regionList.map((_v) => {
              const v = toUpperCase(_v);
              if (regions.includes(v)) {
                const s = taskStatus(tasks[v]!, platform);
                if (s !== 'finish') {
                  rTaskStats.current = 'wait';
                }

                return (
                  <Steps.Step
                    status={rTaskStats.current}
                    data-on={`${btnOn === `task${v}` ? 'on' : ''}`}
                    title={
                      <span
                        onClick={() => {
                          document.querySelector(`[data-step=task${v}]`)?.scrollIntoView();
                          setBtnOn(`task${v}`);
                        }}
                      >
                        {getRegionLabel(v)}
                      </span>
                    }
                  />
                );
              }

              return null;
            })}
          </>
        )}
      </Steps>
    </LeftNav>
  );
};

const LeftNav = styled.div`
  background: #fff;
  width: 240px;
  margin-right: 16px;
  height: fit-content;
  position: sticky;
  top: 0;
  padding: 16px;
  .ant-steps-item-container {
    display: flex;
    align-items: center;
    min-height: 28px;
    margin-bottom: 8px;
  }
  .ant-steps-item-content {
    min-height: initial !important;
  }
  [data-on='on'] .ant-steps-item-container {
    background: #f7f9fa;
    span {
      color: var(--ant-primary-color);
    }
  }
  .ant-steps-item-title {
    span {
      cursor: pointer;
      font-size: 16px;
    }
  }
  .ant-steps-item-tail {
    padding: 28px 0 0 !important;
  }
  .ant-steps-item-icon {
    width: 16px;
    height: 16px;
    line-height: 16px;
    margin: 0 8px 0 4px !important;
  }
`;
